module.exports = __webpack_public_path__ + "static/media/align-left.bccd3f90.svg";